/**
 * SharePoint server-relative folder paths for funding PDFs (Harpwood House).
 * Used by getPdfDownloadUrl() and must stay in sync with server/api PDF_ALLOWED_PATHS.
 */
export const HARPWOOD_WEBLINKS =
  '/sites/WebDocuments/Shared Documents/General/Harpwood/Weblinks';

export const HARPWOOD_ARCHIVE_WEBLINKS =
  '/sites/WebDocuments/Shared Documents/General/Harpwood/Archive/Weblinks';
